import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pre-login',
  template: `<router-outlet></router-outlet>`,
})
export class PreLoginComponent implements OnInit {

  constructor() { }

  ngOnInit() {  window.scroll({top:0,left:0,behavior:"smooth"});
  }

}
